import Bookmark from '../../assets/illustration-features-tab-1.svg'
import Searching from '../../assets/illustration-features-tab-2.svg'
import Sharing from '../../assets/illustration-features-tab-3.svg'
export const FeatureData = [
  {
    id: 1,
    name: 'Simple Bookmarking',
    title: 'Bookmark in one Click',
    description:
      'Organize Your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favourite site.',
    image: Bookmark,
  },
  {
    id: 2,
    name: 'Speedy Searching',
    title: 'Inteligente Search',
    description:
      'Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks',
    image: Searching,
  },
  {
    id: 3,
    name: 'Easy Sharing',
    title: 'Share your bookmarks',
    description:
      'Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button',
    image: Sharing,
  },
]
